<template>
    <div class="container-fluid p-admin-subscription-reviews">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">サービス申込一覧</div>
                    <div class="card-body pt-2">
                        <div class="d-block d-md-flex justify-content-between mb-3">
                            <div class="d-block d-md-flex flex-wrap align-items-center">
                                <div class="mt-2 mb-2 mb-md-0">
                                    <div class="input-group input-group-sm">
                                        <select
                                            v-model="search.plan_id"
                                            @change="onChangeSearchPlanId"
                                            id="plan_id"
                                            class="form-control">
                                            <option :value="null">サービスモデルで検索</option>
                                            <option v-for="plan in plans" :value="plan.id">
                                                {{ plan.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                    <div class="c-freeword input-group input-group-sm">
                                        <input
                                            v-model="search.freeword"
                                            @blur="onChangeSearchFreeword"
                                            type="text"
                                            class="form-control"
                                            placeholder="フリーワード">
                                        <div class="input-group-append">
                                            <div
                                                class="c-freeword__btn input-group-text"
                                                @click="onChangeSearchFreeword">
                                                検索
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">申込日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.created_at_gte"
                                                @change="onChangeSearchCreatedAtGte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.created_at_lte"
                                                @change="onChangeSearchCreatedAtLte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">出国日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_start_gte"
                                                @change="onChangeSearchPeriodStartGte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_start_lte"
                                                @change="onChangeSearchPeriodStartLte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">帰国日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_end_gte"
                                                @change="onChangeSearchPeriodEndGte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.period_end_lte"
                                                @change="onChangeSearchPeriodEndLte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">サービスステータス</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <select
                                                v-model="search.subscription_status"
                                                @change="onChangeSearchSubscriptionStatus"
                                                id="plan_id"
                                                class="form-control">
                                                <option :value="null">ステータスで検索</option>
                                                <option v-for="status in subscriptionStatus.common" :value="status.value">
                                                    {{ status.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">請求ステータス</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <select
                                                v-model="search.invoice_status"
                                                @change="onChangeSearchInvoiceStatus"
                                                id="plan_id"
                                                class="form-control">
                                                <option :value="null">ステータスで検索</option>
                                                <option v-for="status in invoiceStatus.common" :value="status.value">
                                                    {{ status.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block d-md-flex align-items-center">
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <span class="small">返金日</span>
                                    </div>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.refunded_at_gte"
                                                @change="onChangeSearchRefundedAtGte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                    <span class="small mt-2 ml-2">〜</span>
                                    <div class="mt-2 mb-2 ml-md-3 mb-md-0">
                                        <div class="input-group input-group-sm">
                                            <input
                                                v-model="search.refunded_at_lte"
                                                @change="onChangeSearchRefundedAtLte"
                                                type="date"
                                                class="form-control">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :class="{ 'u-loader u-loader--p5' : ! reviews }">
                            <div v-if="reviews">
                                <b-table
                                    hover
                                    striped
                                    responsive
                                    :items="reviews"
                                    :fields="fields"
                                    :sort-by.sync="$store.state.adminSubscriptionReviews.sortBy"
                                    :sort-desc.sync="$store.state.adminSubscriptionReviews.sortDesc"
                                    @sort-changed="fetchSubscriptionReviews"
                                    class="table-bordered m-table">
                                    <template v-slot:cell(created_at)="data">
                                        <div
                                            v-if="data.item.created_at"
                                            class="u-palt">
                                            <span>
                                                {{ helper.dateForHuman(data.item.created_at, timezone) }}
                                            </span>
                                            <span
                                                class="font-weight-bold"
                                                :class="helper.dayForHumanCSS(data.item.created_at , timezone)">
                                                {{ helper.dayForHuman(data.item.created_at, timezone, {bracket: true}) }}
                                            </span>
                                        </div>
                                        <div>
                                            {{ helper.timeForHuman(data.item.created_at , timezone) }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(user_full_name)="data">
                                        <div v-if="data.item.user !== null">
                                            <a
                                                href="#"
                                                @click="showModalUserProfile(data.item.user, $event)">
                                                {{ data.item.user.full_name }}
                                            </a>
                                            <div>{{ data.item.user.full_name_kana }}</div>
                                            <div
                                                v-if="data.item.user.groups.length > 0"
                                                class="mt-1">
                                                <a :href="`/admin/companies/${data.item.user.groups[0].id}`">
                                                    <b-icon-building/>
                                                    <span>{{ data.item.user.groups[0].name }}</span>
                                                </a>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <span class="text-muted">退会済の{{ $locale.patient }}</span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(plan_id)="data">
                                        <div v-if="data.item.plan">{{ data.item.plan.name.replace('プラン', '') }}</div>
                                        <div :class="subscriptionStatusClass(data.item.subscription)">{{ data.item.subscription.status_label }}</div>
                                    </template>

                                    <template v-slot:cell(purpose)="data">
                                        <div>{{ data.item.purpose }}</div>
                                        <div
                                            v-if="isCyclePlan(data.item.plan)"
                                            class="text-muted">
                                            {{ data.item.period_schedule }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(period_start)="data">
                                        <div class="u-palt">
                                            <span>
                                                {{ helper.dateForHuman(data.item.period_start, timezone, { simpleYear: true }) }}
                                            </span>
                                            <span
                                                class="font-weight-bold"
                                                :class="helper.dayForHumanCSS(data.item.period_start , timezone)">
                                                {{ helper.dayForHuman(data.item.period_start, timezone, { bracket: true }) }}
                                            </span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(period_end)="data">
                                        <div
                                            v-if="data.item.period_end !== null"
                                            class="u-palt">
                                            <span>
                                                {{ helper.dateForHuman(data.item.period_end, timezone, { simpleYear: true }) }}
                                            </span>
                                            <span
                                                class="font-weight-bold"
                                                :class="helper.dayForHumanCSS(data.item.period_end , timezone)">
                                                {{ helper.dayForHuman(data.item.period_end, timezone, { bracket: true }) }}
                                            </span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(user_coupon)="data">
                                        <div
                                            v-if="data.item.user_coupon"
                                            class="user_coupon pb-2">
                                            <div>
                                                <span class="u-palt">{{ data.item.user_coupon.name }}</span>
                                                <span class="u-palt small text-muted">{{ `（発行番号: #${data.item.user_coupon.id}）` }}</span>
                                            </div>
                                            <div class="small text-muted">{{ discountMethod(data.item.user_coupon) }}</div>
                                        </div>
                                        <div v-else>
                                            <span class="text-muted">-</span>
                                        </div>
                                    </template>

                                    <template v-slot:cell(invoice_status)="data">
                                        <div v-if="data.item.invoice === null">
                                            <span class="text-muted">未請求</span>
                                        </div>
                                        <div v-else>
                                            <div :class="{ 'is-invalid' : isFailed(data.item.invoice) }">
                                                {{ invoiceStatusFormat(data.item.invoice) }}
                                            </div>
                                            <div class="small text-muted">{{ `請求ID: #${data.item.invoice.id}` }}</div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(refunded_at)="data">
                                        <template v-if="data.item.refunded_at">
                                            <div class="u-palt">
                                                <span>{{ helper.dateForHuman(data.item.refunded_at, timezone) }}</span>
                                                <span
                                                    class="font-weight-bold"
                                                    :class="helper.dayForHumanCSS(data.item.refunded_at , timezone)">
                                                    {{ helper.dayForHuman(data.item.refunded_at, timezone, {bracket: true}) }}
                                                </span>
                                            </div>
                                            <div>{{ helper.timeForHuman(data.item.refunded_at , timezone) }}</div>
                                        </template>
                                    </template>

                                    <template v-slot:cell(links)="data">
                                        <div class="d-flex justify-content-center align-items-center" v-if="data.item.presigned_url">
                                            <b-button
                                                type="button"
                                                class="btn btn-sm mt-1"
                                                variant="yokumiru-blue"
                                                target="_blank"
                                                :href="data.item.presigned_url">
                                                ダウンロード
                                            </b-button>
                                        </div>
                                    </template>
                                </b-table>

                                <div class="d-flex flex-wrap justify-content-between align-items-center">
                                    <b-pagination
                                        :total-rows="$store.state.adminSubscriptionReviews.total"
                                        :per-page="$store.state.adminSubscriptionReviews.per_page"
                                        v-model="$store.state.adminSubscriptionReviews.current_page"
                                        @change="fetchSubscriptionReviews">
                                    </b-pagination>

                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="mr-3 mb-3">
                                            <span class="small">{{ dispPaginationDetail }}</span>
                                        </div>
                                        <div class="mb-3">
                                            <b-button
                                                variant="yokumiru-orange"
                                                @click="downloadCSV"
                                                :disabled="inProgress">
                                                CSVダウンロード
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <admin-user-profile-modal/>
        <admin-doctor-profile-modal/>
        <admin-user-subscription-histories-modal/>
    </div>
</template>

<script>
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'
import { mapMutations } from 'vuex'

export default {
    name: 'AdminSubscriptionReviews',

    props: {
        plans: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            invoiceStatus: constants.invoices,
            subscriptionStatus: constants.subscriptions,
            reviews: null,
            timezone: 'Asia/Tokyo',
            search: {
                plan_id: null,
                freeword: '',
                created_at_gte: null,
                created_at_lte: null,
                period_start_gte: null,
                period_start_lte: null,
                period_end_gte: null,
                period_end_lte: null,
                subscription_status: null,
                invoice_status: null,
                refunded_at_gte: null,
                refunded_at_lte: null,
            },
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'created_at',
                    'label': '申込日時',
                    sortable: true,
                },
                {
                    'key': 'user_full_name',
                    'label': `${this.$locale.patient}名`,
                    sortable: true,
                },
                {
                    'key': 'plan_id',
                    'label': 'サービス',
                    sortable: true,
                },
                {
                    'key': 'purpose',
                    'label': '旅行目的',
                    sortable: false,
                },
                {
                    'key': 'destination',
                    'label': '目的地',
                    sortable: false,
                },
                {
                    'key': 'period_start',
                    'label': '出国日',
                    sortable: true,
                },
                {
                    'key': 'period_end',
                    'label': '帰国日',
                    sortable: true,
                },
                {
                    'key': 'user_coupon',
                    'label': 'クーポン',
                    sortable: true,
                },
                {
                    'key': 'invoice_status',
                    'label': '請求ステータス',
                    sortable: true,
                },
                {
                    'key': 'refunded_at',
                    'label': '返金日時',
                    sortable: true,
                },
                {
                    'key': 'links',
                    'label': '証明書類',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.$store.state.adminSubscriptionReviews.total < 1) {
                return ''
            }
            return `全${this.$store.state.adminSubscriptionReviews.total}件中 ${this.$store.state.adminSubscriptionReviews.from}～${this.$store.state.adminSubscriptionReviews.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()
        this.fetchSubscriptionReviews()
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminSubscriptionReviews/setQuery',
            setQueries: 'adminSubscriptionReviews/setQueries',
        }),

        /**
         * 検索条件の初期化
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminSubscriptionReviews) {
                    this.setQueries(data.adminSubscriptionReviews)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.plan_id = this.$store.state.adminSubscriptionReviews.plan_id
            this.search.freeword = this.$store.state.adminSubscriptionReviews.freeword
            this.search.created_at_gte = this.$store.state.adminSubscriptionReviews.created_at_gte
            this.search.created_at_lte = this.$store.state.adminSubscriptionReviews.created_at_lte
            this.search.period_start_gte = this.$store.state.adminSubscriptionReviews.period_start_gte
            this.search.period_start_lte = this.$store.state.adminSubscriptionReviews.period_start_lte
            this.search.period_end_gte = this.$store.state.adminSubscriptionReviews.period_end_gte
            this.search.period_end_lte = this.$store.state.adminSubscriptionReviews.period_end_lte
            this.search.subscription_status = this.$store.state.adminSubscriptionReviews.subscription_status
            this.search.invoice_status = this.$store.state.adminSubscriptionReviews.invoice_status
            this.search.refunded_at_gte = this.$store.state.adminSubscriptionReviews.refunded_at_gte
            this.search.refunded_at_lte = this.$store.state.adminSubscriptionReviews.refunded_at_lte
        },

        onChangeSearchPlanId: async function () {
            await this.setQuery({ key: 'plan_id', value: this.search.plan_id })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchCreatedAtGte: async function () {
            await this.setQuery({ key: 'created_at_gte', value: this.search.created_at_gte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchCreatedAtLte: async function () {
            await this.setQuery({ key: 'created_at_lte', value: this.search.created_at_lte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchPeriodStartGte: async function () {
            await this.setQuery({ key: 'period_start_gte', value: this.search.period_start_gte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchPeriodStartLte: async function () {
            await this.setQuery({ key: 'period_start_lte', value: this.search.period_start_lte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchPeriodEndGte: async function () {
            await this.setQuery({ key: 'period_end_gte', value: this.search.period_end_gte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchPeriodEndLte: async function () {
            await this.setQuery({ key: 'period_end_lte', value: this.search.period_end_lte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchSubscriptionStatus: async function () {
            await this.setQuery({ key: 'subscription_status', value: this.search.subscription_status })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchInvoiceStatus: async function () {
            await this.setQuery({ key: 'invoice_status', value: this.search.invoice_status })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchRefundedAtGte: async function () {
            await this.setQuery({ key: 'refunded_at_gte', value: this.search.refunded_at_gte })
            await this.fetchSubscriptionReviews(1)
        },

        onChangeSearchRefundedAtLte: async function () {
            await this.setQuery({ key: 'refunded_at_lte', value: this.search.refunded_at_lte })
            await this.fetchSubscriptionReviews(1)
        },

        /**
         * サービス申込一覧取得
         *
         * @param {number|object} param
         */
        fetchSubscriptionReviews: async function (param = null) {
            this.reviews = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.subscription_reviews.endpoint.base

            axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.reviews = data.data
                    this.setQueries(data.meta)
                })
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            const state = this.$store.state.adminSubscriptionReviews

            if (paginate) {
                query += `page=${state.current_page}`
            }
            query += `&sort=${state.sortBy}`
            query += `&desc=${state.sortDesc}`

            if (state.plan_id) {
                query += `&plan_id=${state.plan_id}`
            }
            if (state.freeword && state.freeword.length > 0) {
                query += `&freeword=${state.freeword}`
            }
            if (state.created_at_gte) {
                query += `&created_at_gte=${state.created_at_gte}`
            }
            if (state.created_at_lte) {
                query += `&created_at_lte=${state.created_at_lte}`
            }
            if (state.period_start_gte) {
                query += `&period_start_gte=${state.period_start_gte}`
            }
            if (state.period_start_lte) {
                query += `&period_start_lte=${state.period_start_lte}`
            }
            if (state.period_end_gte) {
                query += `&period_end_gte=${state.period_end_gte}`
            }
            if (state.period_end_lte) {
                query += `&period_end_lte=${state.period_end_lte}`
            }
            if (state.subscription_status) {
                query += `&subscription_status=${state.subscription_status}`
            }
            if (state.invoice_status) {
                query += `&invoice_status=${state.invoice_status}`
            }
            if (state.refunded_at_gte) {
                query += `&refunded_at_gte=${state.refunded_at_gte}`
            }
            if (state.refunded_at_lte) {
                query += `&refunded_at_lte=${state.refunded_at_lte}`
            }

            return query
        },

        /**
         * 会員詳細モーダル表示
         */
        showModalUserProfile: function (user, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-user-profile', user.id)
        },

        /**
         * プラン: 買い切りのプランかどうか
         *
         * @param {object} plan
         */
        isCyclePlan: function (plan) {
            return [constants.planTypes.cycle].includes(plan.plan_type)
        },

        /**
         * ステータス表記
         *
         * @param {object} invoice
         * @return {string}
         */
        invoiceStatusFormat: function (invoice) {
            let result = this.invoiceStatus.all.find(status => {
                return status.value === invoice.status
            })

            if (
                result
                && result.value === constants.invoices.authorized
                && invoice.send_at
                && invoice.payment_method_id !== constants.payment_methods.credit) {
                return '請求済'
            }

            return result ? result.text : ''
        },

        /**
         * 失敗ステータス判定
         *
         * @param {object} invoice
         * @return {boolean}
         */
        isFailed: function (invoice) {
            return invoice.status === this.invoiceStatus.failed
                || invoice.status === this.invoiceStatus.authorizeFailed
        },

        /**
         * 割引方式を返す
         * @param {object} userCoupon
         * @return {string}
         */
        discountMethod: function (userCoupon) {
            if (!userCoupon) return ''

            const discount = userCoupon.discount.toLocaleString()

            if (userCoupon.discount_unit === 'percent') {
                return `${discount}% 割引`
            }
            else if (userCoupon.discount_unit === 'static') {
                return `${discount}円 割引`
            }
            else if (userCoupon.discount_unit === 'daily') {
                return `${discount}円/日 割引`
            }
            return ''
        },

        /**
         * サブスクリプションのステータス表記CSS
         *
         * @param {object} subscription
         * @return {string}
         */
        subscriptionStatusClass: function (subscription) {
            if (subscription.status === this.subscriptionStatus.notStarted) {
                return 'text-success'
            }
            else if (subscription.status === this.subscriptionStatus.active) {
                return 'text-success'
            }
            else if (subscription.status === this.subscriptionStatus.paused) {
                return 'text-danger'
            }
            return 'text-muted'
        },

        /**
         * CSVダウンロード
         */
        downloadCSV: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.subscription_reviews.endpoint.base
            const options = { responseType : 'blob' }

            await axios.get(`${endpoint}/export${this.buildQuery(false)}`, options)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.data.type,
                    })
                    saveAs(
                        blob,
                        sprintf(
                            'サービス申込一覧_%s.csv',
                            moment().format('YYYYMMDD')
                        )
                    )
                })
                .catch(() => {
                    bus.$emit('alert-danger', 'システムエラーが発生しました。')
                })

            this.inProgress = false
        },
    },
};
</script>

<style lang="scss">
.p-admin-subscription-reviews {
    .b-table {
        min-width: 1460px;

        th, td {
            font-size: 0.75rem;
        }
    }
}
</style>

<style scoped lang="scss">
.user_coupon {
    overflow-x: scroll;
    white-space: pre;
    width: 230px;
    padding: 5px 0;
    box-sizing: border-box;
    line-height: 0.8;

    > a {
        display: block;
        padding: 4px 10px;
        color: #212529;
        text-align: center;
        background-color: #dedede;
        border-radius: 15px;
        margin-right: 5px;

        &:last-child {
            padding-right: 15px;
        }
    }
}
</style>
